import { createClient } from '@supabase/supabase-js';

const url = process.env.REACT_APP_SUPABASE_URL;
const key = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!url || !key) {
  console.warn('[Supabase] REACT_APP_SUPABASE_URL or REACT_APP_SUPABASE_ANON_KEY not set - auth disabled');
}

export const supabase = url && key
  ? createClient(url, key)
  : null;
